// the strings are from the marketing team
export const facebookEventNames = {
    live_account_success: 'liveaccount_success',
    simple_account_success: 'simpleaccount_success',
    land_prime_success: 'landprime_success',
    deposit_success: 'deposit'
}

export function sendCustomEvent(eventName, dataObj) {
    if(window.ciEnv === 'uk-eweb')
    {
        if(dataObj)
        {
            fbq('trackCustom', eventName, dataObj);
        }
        else
        {
            fbq('trackCustom', eventName);
        }
    }
}